// component
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfig =
  process.env.REACT_APP_NAME === "olybet"
    ? [
        {
          title: "Pickems",
          path: "/dashboard/pickems",
          icon: icon("ic_analytics"),
        },
        {
          title: "Pages",
          path: "/dashboard/pages",
          icon: icon("file-text-outline"),
        },
        {
          title: "Custom Leagues",
          path: "/dashboard/leagues",
          icon: icon("shield-outline"),
        },
        {
          title: "Friends Leagues",
          path: "/dashboard/friends-leagues",
          icon: icon("people-outline"),
        },
        {
          title: "Image Library",
          path: "/dashboard/image-library",
          icon: icon("image-outline"),
        },
        {
          title: "Banners",
          path: "/dashboard/banners",
          icon: icon("image-outline"),
        },
        {
          title: "Settings",
          path: "/dashboard/settings",
          icon: icon("list-outline"),
        },
      ]
    : [
        {
          title: "Pickems",
          path: "/dashboard/pickems",
          icon: icon("ic_analytics"),
        },
        {
          title: "Pages",
          path: "/dashboard/pages",
          icon: icon("file-text-outline"),
        },
        {
          title: "Custom Leagues",
          path: "/dashboard/leagues",
          icon: icon("shield-outline"),
        },
        {
          title: "Friends Leagues",
          path: "/dashboard/friends-leagues",
          icon: icon("people-outline"),
        },
        {
          title: "Image Library",
          path: "/dashboard/image-library",
          icon: icon("image-outline"),
        },
        {
          title: "Banners",
          path: "/dashboard/banners",
          icon: icon("image-outline"),
        },
        {
          title: "Settings",
          path: "/dashboard/settings",
          icon: icon("list-outline"),
        },
        {
          title: "Login Toast",
          path: "/dashboard/login-toast",
          icon: icon("alert-circle-outline"),
        },
        {
          title: "Players Stats",
          path: "/dashboard/stats",
          icon: icon("pantone-outline"),
        },
        {
          title: "Goalies",
          path: "/dashboard/fixtures-squad",
          icon: icon("lock-outline"),
        },
        {
          key: "prize-draws",
          title: "Prize Draws",
          path: "/dashboard/prize-draws",
          icon: icon("gift-outline"),
        },
        {
          key: "users",
          title: "Users",
          path: "/dashboard/users",
          icon: icon("people-outline"),
        },
        {
          key: "ticket-transactions",
          title: "Ticket Transactions",
          path: "/dashboard/ticket-transactions",
          icon: icon("transactions"),
        },
        {
          key: "notifications",
          title: "Notifications",
          path: "/dashboard/notifications",
          icon: icon("menu-2-outline"),
        }
      ];

export default navConfig;
